/**
 * Single source of truth for permission-denial copy, so the wording is
 * identical across `PermissionRoute`, `NoAccessState`, and every per-page
 * disabled-action tooltip instead of ~35 hand-written variants.
 */
export const noAccessTitle = (moduleName) => `You don't have access to ${moduleName}`;

export const noAccessDescription = "Ask your admin or owner to grant you access.";

export const noPermissionTooltip = (action) =>
  `You don't have permission to ${action}. Ask your admin or owner for access.`;
